/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './bulk-provisioning.scss';

/*@ngInject*/
export default function GatewayBulkProvisioningController($mdDialog, $stateParams, $q, $translate, types, entityTableConfiguration,
                                                          importExport, entityService, gatewayService, credentialsService) {
    var vm = this;

    vm.$onInit = function () {
        vm.fileContent = undefined;
        vm.headerColumns = [];

        vm.gwModels = [];

        vm.selectedGwModel = undefined;
        vm.selectedColumnValueForName = [];
        vm.selectedColumnValueForDescription = [];
        vm.selectedColumnsForLocation = {};
        vm.addAllOtherColumnsToDescription = true;
        vm.enableLogging = false;
        vm.allowUdp = false;
        vm.allowNotTlsConnection = false;

        vm.provisioningResult = '';
        vm.numberOfCreatedGateways = 0;

        vm.idIncrementor = 0;

        vm.close = close;
        vm.importFromCsv = importFromCsv;
        vm.downloadExampleFile = downloadExampleFile;
        vm.startProvisioning = startProvisioning;
        vm.transformChipsForNamePattern = transformChipsForNamePattern;

        entityService.getEntities(types.entityType.gateway_model).then(
            (gwModels) => {
                vm.gwModels = gwModels;
            }
        );
    };

    function close() {
        $mdDialog.cancel();
    }

    function importFromCsv($event) {
        importExport.uploadFile($event, [types.fileType.CSV],
            'bulk-provisioning.import-data', 'bulk-provisioning.result-file').then(
            (csvData) => {
                vm.fileContent = csvData;
                vm.headerColumns = vm.fileContent.split(/[\r\n]+/)[0].split(',');
            },
            function fileSelectCanceled() {
            });
    }

    function downloadExampleFile() {
        const fileContent = generateExampleFile();
        importExport.downloadFile(fileContent, 'Gateway_Bulk_Commissioning_sample', types.fileType.CSV);
    }

    function generateExampleFile(){
        const columnHeaders = ["NAME", types.bulk_provisioning.gw_id_column];
        const exampleValues = {
            name: "GATEWAY",
            id: "647FDA000000A00"
        }
        let csvData = columnHeaders.join(',') + '\n';
        for (let i = 0; i < 5; i++) {
            let row = [];
            row.push(exampleValues.name + " " + (i + 1));
            row.push(exampleValues.id + i);
            csvData += row.join(',') + '\n';
        }
        return csvData;
    }

    function startProvisioning() {
        var rows = vm.fileContent.split(/[\r\n]+/);
        var rowValues = [];
        var tasks = [];

        for (var i = 1; i < rows.length; i++) {
            rowValues = rows[i].split(',');
            if (vm.headerColumns.length === rowValues.length) {
                const gwId = getColumnValue(vm.headerColumns, rowValues, types.bulk_provisioning.gw_id_column),
                    gwName = getGwName(vm.headerColumns, rowValues, vm.selectedColumnValueForName),
                    gwLocation = getGwLocation(vm.headerColumns, rowValues, vm.selectedColumnsForLocation),
                    mqttUsername = getColumnValue(vm.headerColumns, rowValues, types.bulk_provisioning.mqtt_username_column),
                    mqttPassword = getColumnValue(vm.headerColumns, rowValues, types.bulk_provisioning.mqtt_password_column);

                var columnsToSkip = vm.selectedColumnValueForName.map(columnName => columnName.name).slice();
                columnsToSkip.push(types.bulk_provisioning.gw_id_column);
                columnsToSkip.push(types.bulk_provisioning.mqtt_username_column);
                columnsToSkip.push(types.bulk_provisioning.mqtt_password_column);
                skipLocationColumn(columnsToSkip, vm.selectedColumnsForLocation.location);
                skipLocationColumn(columnsToSkip, vm.selectedColumnsForLocation.latitude);
                skipLocationColumn(columnsToSkip, vm.selectedColumnsForLocation.longitude);
                skipLocationColumn(columnsToSkip, vm.selectedColumnsForLocation.altitude);
                var gwDescription = getGwDescription(vm.headerColumns, rowValues, columnsToSkip);

                tasks.push(createGateway(gwId, gwName, gwDescription, gwLocation, mqttUsername, mqttPassword));
            } else if (rowValues.length === 1 && !rowValues[0].trim().length) {
                // Do not show a warning if a processed file's line is empty, continue to process the next line.
            } else {
                vm.provisioningResult += $translate.instant('bulk-provisioning.wrong-column-number', {
                    numberOfCellsInRow: rowValues.length,
                    rowNumber: i + 1,
                    numberOfCellsInHeader: vm.headerColumns.length,
                }) + '\n';
            }
        }

        $q.all(tasks).then(() => {
            vm.provisioningResult += '\n' + $translate.instant('bulk-provisioning.result', {
                count: vm.numberOfCreatedGateways,
                entityType: $translate.instant('gateway.gateways')
            });
            entityTableConfiguration.reloadEntities();
        });
    }

    function skipLocationColumn(columnsToSkip, locationParam) {
        if (locationParam) {
            columnsToSkip.push(locationParam);
        }
    }

    function getColumnValue(headerColumns, rowValues, columnName) {
        const columnIdx = headerColumns.indexOf(columnName);
        return rowValues[columnIdx];
    }

    function getGwName(headerColumns, rowValues, columnsToComposeGwName) {
        var gwName = '';

        for (var i = 0; i < columnsToComposeGwName.length; i++) {
            var columnIdx = headerColumns.indexOf(columnsToComposeGwName[i].name);
            var columnValue = columnsToComposeGwName[i].name;

            // If name part isn't equal to any of header columns, then it's raw value is used.
            if (columnIdx !== -1) {
                columnValue = rowValues[columnIdx];
            }
            gwName += columnValue;
        }
        return gwName;
    }

    function getGwDescription(headerColumns, rowValues, columnsToSkip) {
        var gwDescription = [];
        for (var i = 0; i < rowValues.length; i++) {
            var columnName = headerColumns[i];
            if (!columnsToSkip.includes(columnName)) {
                if (vm.addAllOtherColumnsToDescription) {
                    gwDescription.push(`${columnName} - ${rowValues[i]}`);
                } else {
                    if (vm.selectedColumnValueForDescription.includes(columnName)) {
                        gwDescription.push(`${columnName} - ${rowValues[i]}`);
                    }
                }
            }
        }
        return gwDescription.join('\n');
    }

    function getGwLocation(headerColumns, rowValues, columnsToComposeLocation) {
        var location = {};
        location.location = addLocationParam(headerColumns, rowValues, columnsToComposeLocation.location);
        location.latitude = addLocationParam(headerColumns, rowValues, columnsToComposeLocation.latitude);
        location.longitude = addLocationParam(headerColumns, rowValues, columnsToComposeLocation.longitude);
        location.altitude = addLocationParam(headerColumns, rowValues, columnsToComposeLocation.altitude);
        return location;
    }

    function addLocationParam(headerColumns, rowValues, locationParam) {
        var localtionColumnIdx = headerColumns.indexOf(locationParam);
        if (localtionColumnIdx !== -1) {
            var columnValue = +rowValues[localtionColumnIdx];
            if (!isNaN(columnValue)) {
                return columnValue;
            }
        }
    }

    function createGateway(gwMac, gwName, description, gwLocation, mqttUsername, mqttPassword) {
        let data = {
            gatewayModelId: {
                entityType: types.entityType.gateway_model,
                id: vm.selectedGwModel.id.id
            },
            name: gwName,
            mac: gwMac,
            logEnabled: vm.enableLogging,
            allowUdp: vm.allowUdp,
            allowNotTlsConnection: vm.allowNotTlsConnection,
            gatewayGroupId: {
                entityType: types.entityType.gateway_group,
                id: $stateParams.gatewayGroupId
            },
            description: description
        };

        Object.assign(data,
            gwLocation.location && {location: gwLocation.location},
            gwLocation.latitude && {lat: gwLocation.latitude},
            gwLocation.longitude && {lng: gwLocation.longitude},
            gwLocation.altitude && {altitude: gwLocation.altitude}
        );

        var deferred = $q.defer();
        gatewayService.saveGatewayMassCommissioning(data).then(
            (response) => {
                if (angular.isDefined(mqttUsername) && angular.isDefined(mqttPassword)) {
                    updateCredentials(response, mqttUsername, mqttPassword, deferred);
                }
                vm.numberOfCreatedGateways++;
                deferred.resolve();
            },
            (error) => {
                vm.provisioningResult += error.data.message + '\n';
                deferred.resolve();
            });
        return deferred.promise;
    }

    function updateCredentials(gateway, mqttUsername, mqttPassword, deferred) {
        let entityId = gateway.id;
        credentialsService.getCredentials(entityId.entityType, entityId.id).then(
            (credentials) => {
                credentials.keyId = mqttUsername;
                credentials.keyValue = mqttPassword;

                credentialsService.saveCredentials(credentials).then(
                    (error) => {
                        vm.provisioningResult += error.data.message + '\n';
                        deferred.resolve();
                    });
            });
    }

    function transformChipsForNamePattern(chip) {
        return {
            id: ++vm.idIncrementor,
            name: chip
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway/bulk-provisioning/bulk-provisioning.controller.js